import { logError } from '@com-delta-idp/mnx-utils';
import { EdocBrands } from '../../header/navigation-book/navigation-book.model';
import {
  SavedSearchGQL,
  SavedTripResponse
} from '../../model/saved-search/saved-search.interface';

export const isValidSearch = (search: SavedSearchGQL): boolean => {
  return (
    !!search.destination_city &&
    !!search.origin_city &&
    !!search.passenger_count
  );
};

const transformResponseToTrip = (
  search: SavedSearchGQL,
  brands: EdocBrands[]
): SavedTripResponse => {
  return {
    alias: search.trip_alias,
    cabinClassCode: search.cabin,
    cabinClassDescription: brands.find((brand) => brand.brandId == search.cabin)
      ?.brandTitle,
    destinationCityCode: search.destination_city,
    originCityCode: search.origin_city,
    passengerCount: search.passenger_count,
    travelType: search.trip_reason
  };
};

export const getTripList = (
  searches: SavedSearchGQL[],
  brands: EdocBrands[]
): SavedTripResponse[] => {
  let tripList: SavedTripResponse[] = [];
  try {
    if (searches) {
      searches?.forEach((item) => {
        if (isValidSearch(item)) {
          tripList.push(transformResponseToTrip(item, brands));
        }
      });
    }
  } catch (error) {
    logError(error as Error, 'HEADER', 'SHARED', 'SAVED_SEARCH_TRIP');
  }
  return tripList;
};
